import { render, staticRenderFns } from "./SelectTree.vue?vue&type=template&id=96fae4dc&scoped=true"
import script from "./SelectTree.vue?vue&type=script&lang=js"
export * from "./SelectTree.vue?vue&type=script&lang=js"
import style0 from "./SelectTree.vue?vue&type=style&index=0&id=96fae4dc&prod&lang=scss&scoped=true"
import style1 from "./SelectTree.vue?vue&type=style&index=1&id=96fae4dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fae4dc",
  null
  
)

export default component.exports